import { AppLoginModule } from "./pages/login/login.module";
import { APP_BASE_HREF } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CoreModule } from "./@core/core.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppRecupMdpModule } from "./pages/recupMDP/recupMDP.module";
import { AppRegisterModule } from "./pages/register/register.module";
import { AccueilService } from "./services/accueil.service";
import { ActiviteService } from "./services/activite.service";
import { AdminService } from "./services/admin.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "./services/authentication.service";
import { EtapesuiviService } from "./services/etapesuivi.service";
import { TiersService } from "./services/tiers.service";
import { HistotiersService } from "./services/histotiers.service";
import { CgvvalidService } from "./services/cgvvalid.service";
import { AppSettingsService } from "./services/appsettings.service";
import { ArtcliService } from "./services/artcli.service";
import { ArtcliuserService } from "./services/artcliuser.service";
import { ArtentService } from "./services/artent.service";
import { AuthAdminService } from "./services/auth-admin.service";
import { AuthGrappeHBService } from "./services/auth-grappeHB.service";
import { CategorieService } from "./services/categorie.service";
import { ConvalsysService } from "./services/convalsys.service";
import { DetailedorderService } from "./services/detailedorder.service";
import { DespatchadviceService } from "./services/despatchadvice.service";
import { DeviseService } from "./services/devise.service";
import { EbizService } from "./services/ebiz.service";
import { SyntheticorderService } from "./services/syntheticorder.service";
import { FacentService } from "./services/facent.service";
import { FacligService } from "./services/faclig.service";
import { HistosessionService } from "./services/histosession.service";
import { InfrumService } from "./services/infrum.service";
import { PaysService } from "./services/pays.service";
import { varGlobal } from "./shared/varGlobal";
import { LangueService } from "./services/langue.service";
import { MoisService } from "./services/mois.service";
import { MsgcountService } from "./services/msgcount.service";
import { NatureService } from "./services/nature.service";
import { RegvenService } from "./services/regven.service";
import { SelectorderService } from "./services/selectorder.service";
import { SessionService } from "./services/session.service";
import { StamsgentService } from "./services/stamsgent.service";
import { SyntheticdespatchadviceService } from "./services/syntheticdespatchAdvice.service";
import { TiersrelentService } from "./services/tiersrelent.service";
import { TiersrelligService } from "./services/tiersrellig.service";
import { TraitementsService } from "./services/traitements.service";
import { TvatauxService } from "./services/tvataux.service";
import { TypvenService } from "./services/typven.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ToasterModule } from "angular2-toaster";
import { ContextMenuModule } from "ngx-contextmenu";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { FacturationService } from "./services/facturation.service";
import { FactvisuService } from "./services/factvisu.service";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    AppLoginModule,
    ContextMenuModule,
    AppRegisterModule,
    AppRecupMdpModule,
    ToasterModule,
    ScrollToModule.forRoot(),
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    varGlobal,
    AccueilService,
    ActiviteService,
    AdminService,
    AppSettingsService,
    ArtcliService,
    ArtcliuserService,
    ArtentService,
    AuthAdminService,
    AuthGrappeHBService,
    AuthenticationService,
    CategorieService,
    CgvvalidService,
    ConvalsysService,
    DespatchadviceService,
    DetailedorderService,
    DeviseService,
    EbizService,
    EtapesuiviService,
    FacentService,
    FacligService,
    FacturationService,
    FactvisuService,
    HistosessionService,
    HistotiersService,
    InfrumService,
    LangueService,
    MoisService,
    MsgcountService,
    NatureService,
    PaysService,
    RegvenService,
    SelectorderService,
    SessionService,
    StamsgentService,
    SyntheticdespatchadviceService,
    SyntheticorderService,
    TiersrelentService,
    TiersrelligService,
    TiersService,
    TraitementsService,
    TypvenService,
    TvatauxService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/app.module.ts